import AttendanceDevice from '@/api/hr/attendance-device'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  deviceTypes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  SET_DEVICE_TYPES(state, data) {
    state.deviceTypes = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return AttendanceDevice.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return AttendanceDevice.store(data)
  },

  update(context, data) {
    return AttendanceDevice.update(data)
  },

  destroy(context, id) {
    return AttendanceDevice.destroy(id)
  },

  async dataBeforeCreate(context) {
    if (!context.state.deviceTypes.length > 0) {
      let response = await AttendanceDevice.deviceType()
      context.commit('SET_DEVICE_TYPES', response.data)
    }
  }
}
